var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 43,
    viewBox: "0 0 80 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3228 0.968672C57.3228 0.968672 90.5733 -1.30491 73.7784 11.9845C59.9036 22.9633 1.41071 41.5112 1.41071 41.5112M1.41071 41.5112C1.41071 41.5112 7.3271 40.7045 17.4584 38.401C27.5902 36.0975 30.7728 35.0173 30.7728 35.0173M1.41071 41.5112C1.41071 41.5112 6.70173 39.7063 13.4701 35.4412C20.2388 31.176 21.8622 28.9278 21.8622 28.9278",
    stroke: "#F4F4F4",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideDownArrow);
export default __webpack_public_path__ + "static/media/slide-down-arrow.3f23f2a2bd3e2333462bc01d44ae7dfa.svg";
export { ForwardRef as ReactComponent };